import React from "react";
import "./StrategySection.css";

const StrategySection = ({ imageSrc, checkboxIcon }) => {
  const redirect = () => {
    window.location.href = "/resilient-fund";
  };
  return (
    <div className="strategy-container">
      <p className="strategy-title">Our Strategy</p>
      <p className="strategy-subtitle">
        Our investment thesis envisages participation in the value-creation
        process while preserving the invested capital
      </p>
      <div className="strategy-content">
        <img
          className="strategy-image"
          src={imageSrc}
          alt="Strategy Illustration"
        />
        <div className="strategy-card">
          <div className="strategy-item">
            <img src={checkboxIcon} alt="Checkbox" className="checkbox-icon" />
            <span>How Do We Operate?</span>
          </div>
          <div className="strategy-item">
            <img src={checkboxIcon} alt="Checkbox" className="checkbox-icon" />
            <span>How Do We Contribute?</span>
          </div>
          <div className="strategy-item">
            <img src={checkboxIcon} alt="Checkbox" className="checkbox-icon" />
            <span>How Do We Add Value To Our Investors?</span>
          </div>
          <div className="strategy-button-container">
            <button className="strategy-button" onClick={redirect}>
              Know More →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrategySection;
